import React, { useEffect, useRef } from "react";
import "./App.scss";
import Main from "./containers/Main";
import AiDisclosure from "./containers/ai/AiDisclosure";
import Privacy from "./containers/privacy/Privacy";
import { Routes, Route, useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

const isFirstRender = useRef(true);

useEffect(() => {
  // gtag unchanged
  // if (window.gtag) {
  //   window.gtag("config", "G-L920CFRBNL", {
  //     page_path: location.pathname + location.search,
  //   });
  // }

  // Skip first render — tracker.js already fired pageview on load
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }

  // Only fires on subsequent SPA route changes
  if (window.tracker) {
    window.tracker.track("pageview", {
      path: location.pathname + location.search,
    });
  }
}, [location]);
  // ── Global click tracking ──
  useEffect(() => {
    const handler = (e) => {
      const anchor = e.target.closest("a");
      if (!anchor) return;

      if (anchor.href.includes("resume")) {
        window.tracker?.track("click_resume", { href: anchor.href });
      }
      if (anchor.href.startsWith("mailto:")) {
        window.tracker?.track("click_email", { href: anchor.href });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/ai" element={<AiDisclosure />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default App;